import styled from "@emotion/styled";
import BgImageBeach from "@images/bg-image-beach.png";
import LogoRemaxAzul from "@images/remax-logo-azul.png";
import LogoRemax from "@images/remax-logo.png";
import { forwardRef } from "react";
import { css } from "@emotion/react";

import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";

const version = import.meta.env;
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import MxTypography from "@rf-l1/MxTypography";
/**
 * @params ${children} set form or jsx.element wrapped
 * $0
 */

const WrapperContent = forwardRef((props: IWrapperContent, ref: any) => {
  return (
    <ContentWrapBg ref={ref} id="WrapperContent">
      <FormSectionsContent className="slide-right">
        <WrapContent>
          <FormSectionsLogo>
            <img src={LogoRemax} />
          </FormSectionsLogo>
          <FormSectionsForm>{props.children}</FormSectionsForm>
        </WrapContent>
      </FormSectionsContent>
      <FooterInformation>
        <img src={LogoRemaxAzul} alt="" />
        <MxTypography variant="overline" className="--description">
          Sistema de propiedades para agentes. Ver. {ENVIRONMENT_VAR.VERSION}
        </MxTypography>
        <MxTypography variant="overline" className="--powerBy">
          Power by{" "}
          <a href="https://version.do/" target="_black">
            VERSION DO
          </a>
        </MxTypography>
      </FooterInformation>
    </ContentWrapBg>
  );
});

export default WrapperContent;

interface IWrapperContent {
  children: any;
}
const ContentWrapBg = styled.div`
  display: block;
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  background-image: url(${BgImageBeach});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const WrapContent = styled.div`
  min-height: 400px;
  width: auto;
  display: flex;
  flex-wrap: wrap;
  background: var(--color-blue-main);
`;

const formSection = css`
  width: 400px;
  min-height: 400px;
  @media (max-width: 799px) {
    min-height: 0px;
  }
  @media (max-width: 409px) {
    width: 100%;
  }
`;

const FormSectionsContent = styled(Grid2)`
  width: 100%;
  height: 89.5dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 150px;
    height: auto;
  }
  @media (max-width: 799px) {
    flex-direction: column;
  }
`;
const FooterInformation = styled.div`
  width: 100%;
  height: 10.5dvh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #f7f7f7;
  gap: 4px;
  padding: 17px 0px 8px 0px;
  img {
    width: 120px;
    height: auto;
  }
  p,
  span {
    line-height: 10px;
  }
  & .--description {
    font-size: 12px;
    color: #636363;
    margin-top: 2px;
  }
  & .--powerBy {
    font-size: 11px;
    color: #636363;
    margin-top: 1px;

    a {
      line-height: 10px;

      color: #5db748;
      text-decoration: none;
    }
  }
`;

const FormSectionsLogo = styled(Grid2)`
  ${formSection}
  background: var(--color-blue-main);
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 799px) {
    height: 75px;
  }
`;
const FormSectionsForm = styled(Grid2)`
  ${formSection}
  background: var(--color-white);
  padding: 18px 28px;
  @media (max-width: 409px) {
    padding: 10px 8px;
  }
`;
